import defaultLang from 'antd/es/locale/ar_EG';
import {Locale} from "antd/es/locale-provider";
import {PickerLocale as DatePickerLocale} from "antd/es/date-picker/generatePicker";

import ar from "dayjs/locale/ar.js";

const getDatePicker = (): DatePickerLocale | undefined => {
    if (defaultLang.DatePicker !== undefined) {
        return {
            dateFormat: "DD.MM.YYYY",
            lang: {
                ...defaultLang.DatePicker.lang,
                dateFormat: "DD.MM.YYYY",
                locale: "ar-QA",
                today:'اليوم',
                dateTimeFormat:"DD.MM.YYYY HH:mm:ss",
                monthFormat:"MMM",
                placeholder:'تاريخ',
                shortMonths: ar.monthsShort,
                shortWeekDays:ar.weekdaysShort,
                now:'شمدي'

            },
            dateTimeFormat:"DD.MM.YYYY HH:mm:ss",
            timePickerLocale: {
                placeholder: 'وقت',

            },
            weekFormat: defaultLang.DatePicker.weekFormat,
            monthFormat: defaultLang.DatePicker.monthFormat,
        }
    } else {
        return undefined;
    }

}
const arQA: Locale = {
    ...defaultLang,
    locale: "ar-QA",
    DatePicker: getDatePicker(),

}
export default arQA;